import React, { useState, useEffect } from 'react'
import Selector from '../Select/Select'
import styles from './StudentSelects.module.css'
import { observer } from 'mobx-react-lite'
import { student } from '../../store/student.ts'
import { directory } from '../../store/directory'
import http from './../../Service/http'
import { getfacultyList, getFEducList, getRateList, getGroupList, getYearList } from '../../Service/selector'
import { useTranslation } from 'react-i18next'

export default observer(function StudentSelects({}) {
	const [dsblList, setDsblList] = useState([false, false, false])
	const [year, setYear] = useState({
		label: '',
		value: 0
	})

	const { t, i18n } = useTranslation()
	const [faculty, setFaculty] = useState(0)
	const [fEduc, setFEduc] = useState(0)
	const [rate, setRate] = useState(0)
	const [group, setGroup] = useState(0)

	const postYearList = async () => {
		const res = await getYearList()
		const defaultYear = res.data.filter(item => item.defaultValue === 1)[0]
		setYear({
			label: defaultYear.p32,
			value: defaultYear.id_a_year
		})
		const years = []
		res.data.map(item => {
			years.push({
				label: item.p32,
				value: item.id_a_year
			})
		})
		directory.getYearList(years)
	}

	const postKafedrasList = async () => {
		const res = await getfacultyList()
		directory.getFacultyList(res.data)
	}

	const postFEducList = async idFaculty => {
		const res = await getFEducList(idFaculty)
		directory.getFEducList(res.data)
	}

	const postRateList = async (fEduc, idFaculty) => {
		const res = await getRateList(fEduc, idFaculty)
		directory.getRateList(res.data)
	}

	const postGroupList = async param => {
		const res = await getGroupList(year.value, faculty.value, fEduc.value, param)
		directory.getGroupList(res.data)
	}

	function onChangeYear(select) {
		setYear(select)
		setDsblList([true, true, true])
		setFaculty(0)
		setFEduc(0)
		setRate(0)
		setGroup(0)
	}

	function onChangeFaculty(select) {
		setFaculty(select)
		setDsblList([false, true, true])
		setFEduc(0)
		setRate(0)
		setGroup(0)
		postFEducList(select.value)
	}

	function onChangeFEduc(select) {
		setFEduc(select)
		setDsblList([false, false, true])
		postRateList(select.value, faculty.value)
		setRate(0)
		setGroup(0)
	}

	async function onChangeRate(select) {
		await setRate(select)
		await setDsblList([false, false, false])
		await setGroup(0)
		postGroupList(select.value)
	}

	function onChangeGroup(select) {
		setGroup(select)
		getStudList(select.value)
	}

	async function getStudList(groupNum) {
		const res = await http.post('/student-by-group', {
			id_a_year: year.value,
			id_f_educ: fEduc.value,
			id_faculty: faculty.value,
			id_rate: rate.value,
			id_group: groupNum
		})
		student.newStudents(res.data.data.StudentList ? res.data.data.StudentList : [])
	}
	useEffect(() => {
		postYearList()
		postKafedrasList()
	}, [])

	useEffect(() => {}, [i18n])

	return (
		<div className={styles.StudentSelects}>
			<Selector
				withBorder={true}
				title={t('st:selects.educYaer')}
				placeholder={t('st:selects.select')}
				options={directory.yearList}
				value={year}
				onChange={e => onChangeYear(e)}
			/>
			<div className={styles.faculty}>
				<Selector
					withBorder={true}
					title={t('st:selects.faculty')}
					placeholder={t('st:selects.select')}
					value={faculty}
					options={directory.facultyList}
					onChange={e => onChangeFaculty(e)}
				/>
			</div>
			<Selector
				withBorder={true}
				title={t('st:selects.educ_form')}
				placeholder={t('st:selects.select')}
				value={fEduc}
				options={directory.fEducList}
				onChange={e => onChangeFEduc(e)}
				isDisabled={false}
			/>
			<Selector
				withBorder={true}
				title={t('st:selects.rate')}
				placeholder={t('st:selects.select')}
				value={rate}
				options={directory.rateList}
				onChange={e => onChangeRate(e)}
				isDisabled={dsblList[1]}
			/>
			<Selector
				withBorder={true}
				title={t('st:selects.group')}
				placeholder={t('st:selects.select')}
				value={group}
				options={directory.groupList}
				onChange={e => onChangeGroup(e)}
				isDisabled={dsblList[2]}
			/>
		</div>
	)
})
